import { Injectable } from '@angular/core';
import { ToastController } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class ModelService {
  constructor(public toastController:ToastController) {}
  async presentToast() {
    const toast = await this.toastController.create({
      message: 'ທ່ານອອກຈາກລະບົບສຳເລັດແລ້ວ',
      duration: 2000,
      position: 'bottom',
      mode: 'ios',
      color: 'dark'
    });
    toast.present();
  }
}
export interface IOrderAssigned {riderUuid:string,orderUuid:string,storeUuid:string}
export enum ECommand {
  ping = 'ping',
  login = "login",
  orderAssigned = "orderAssigned",
  storeaccepted = "storeaccepted"
}

export interface IReqModel {
    data: ISocketData;
    time: string;
    ip: string;
}

export interface ISocketData{
  command:ECommand,
  token?:string,
  time?:Date,
  data?:any
}
export interface ICart {
  storeUuid: string;
  product: IProduct
  isAddon: boolean
  qtty:number;
  value:number;
  ttqtty:number;
  ttvalue:number;
}

export interface IBase {
  id?: number;
  uuid?: string;
  isActive?: boolean;
  createdAt?: string;
  updatedAt?: string;
  // deletedAt?:Date;
}
export interface IProductPost {
  ownerUuid: string;
  primaryProduct: IProductDetails;
  secondaryProducts: Array<IProductDetailsCompact>;
  addons: Array<IProductDetailsCompact>;
  productType: string;
  tags: Array<string>;
  prices: Array<number>;
  min: number;
  max: number;
  average: number;
  expiry_date: Date;
  saleCode: string;
  description: string;
  district: string;
  province: string;
  storeType: string;
}
export interface IProductDetails {
  inventory: IStock, product: IProduct
}
export interface IProductStocks {
  stock: Array<IStock>, product:Array<IProduct>
}
export interface IProductDetailsCompact {
  inventUuid: string, productUuid: string
}
export interface IProduct extends IBase {
  productTypes: string;
  productCode: string;
  productSN: string;
  manufacturer: string;
  weight: string;
  name: string;
  image: string;//path[]
  description: string;
  brand: string;
  unit: string;
  sku: string;
  tags: Array<string>;
  storeType: string;
  storeUuid: string;
  moreDetail: any;
  mrp: string;
  pic?:any;
  product?:any;
}
export interface ISpec {
  color: string;
  dimensionPackage: string;
  dimensionNet: string;
  size: string;
  weight: string
}


export interface IStock extends IBase {
  productUuid: string;
  qtt: number;
  ttqtty: number;
  value: number;
  ttvalue: number;
  description: string;
  bywhom: string;
  direction: EDirection;
  expired: Date | undefined;
  ref: string;
}

export enum EDirection {
  sell = 'sell',
  defective = 'defective',
  expired = 'expired',
  lost = 'lost',
  stolen = 'stolen',
  warranty = 'warranty',
  others = 'others',


  purchase = 'purchase',
  reimport = 'reimport',
  transfer = 'transfer'
}
export interface IInventoryPS {
  primary: IStock,
  secondary: Array<IStock>
}
export interface IResponse {
  data:any;
 message: string,
 code: string,
 status: number
}
export interface IResponseInventory extends IResponse {
  data: IInventoryPS;

}



export interface IStoreConfig {
  storeUuid: string;
  rangefee: Array<IRangeFee>; //jsonb
  packagefee: Array<IPackageFee>; //jsonb
  location: IAddress; //jsonb
  paymentMethodUuid: Array<string>;
  shipmentMethodUuid: Array<string>;
}
export interface IRangeFee {
  radius: number;
  fee: number;
}
export interface IPackageFee {
  fee: number;
  weight: number;
  length: number;
  width: number;
  height: number;
  volume: number;
}

export interface IPaymentMethod extends IBase {
  name: string;
  logo: string;
  description: string;
  feerange: Array<IPaymentMethodFee>;
}
export interface IShipmentMethod extends IBase {
  name: string;
  logo: string;
  description: string;
  feerange: Array<IShipmentMethodFee>;
}

export interface IShipmentMethodFee {
  width: number;
  length: number;
  height: number;
  volume: number;
  weight: number;
  fee: number
}
export interface IPaymentMethodFee {
  fee: number;
  max: number;
}

export interface IAddress extends IBase {
  storeUuid: string;
  name: string;
  address: string;
  road: string;
  village: string;
  district: string;
  province: string;
  country: string;
  description: string;
  location: IGPSLocation;
}
export interface IGPSLocation {
  lat: number;
  lng: number;
  alt: number;
  gpsTime: string;
  serverTime: string;
}







// ============ order =====================

export interface Iorder{
  order:IOrder,detail:IOrderDetails
}
export interface IOrder extends IBase {
  orderStatus:EOrderStatus; // enum order status
  customerName:string; //
  customerToken:string; //
  totalQuantity:number;
  totalValue:number;
  paymentType:any;
  shipmentDetails:any;
  storeUuid:string;
}
// orderDetails
export interface IOrderDetails extends IBase{
  orderUuid:string;
  itemUuid:string; // ==> product uuid
  quantity:number;
  value:number;
  totalValue:number;
  addons:any;
}

export enum EOrderStatus {
  cancel = 'cancel',
  new='new', //new order
  accepted='accepted',
  pending='pending', // waiting for store send request to rider or wait user pay order
  waiting='waiting', // waiting for delivery
  delivering = 'delivering',//4 keep monitoring after issue invoice
  delivered = 'delivered',//5 waiting for receipt after payment
  completed='completed',
  rider_accepted='rider_accepted',
  pickup='pickup', // waiting for user


  quotation = 'quotation', // 1 placed order not yet paid
  booked = 'booked', // 2  reserved is as the same as quotation
  ordered = 'ordered', //3  issue invoice
  pos = 'pos' //  6. pos type as not for online selling,
}